/* 司馬懿傳・第 2 章：五丈原（234 年）
 * 渭水東西橫過地圖中間。北岸是司馬懿來的路與北原（郭淮據守）；南岸是魏軍「背水為壘」的大營。
 * 西南是五丈原：一塊四面陡坡的台地，諸葛亮的營壘在上面，東面有一條坡道。西南角是斜谷口（蜀軍退走的地方）。 */
export const CAMP = [5600, 2950], CAMP_R = 640, GATE = [4900, 3000], NORTH = [5900, 700], BEIYUAN = [3000, 1100];
export const YUAN = [2200, 3700], RAMP = [3300, 3550], VALLEY = [500, 4650], HALT = [2400, 2600];
export default {
  id: 'simayi_wuzhang', name: '五丈原', W: 8800, H: 5000, seed: 2342,
  bases: [CAMP, YUAN],
  rivers: [{ pts: [[-100, 1950], [2500, 1850], [5000, 1980], [7000, 1900], [8900, 1960]], hw: 170, fords: [] }],
  roads: [
    { pts: [NORTH, [5800, 1500], [5700, 2300], CAMP], w: 150 },
    { pts: [[5800, 1500], [4200, 1300], BEIYUAN], w: 110 },
    { pts: [CAMP, GATE, [4200, 3100], RAMP, YUAN, [1300, 4200], VALLEY], w: 130 },
  ],
  // 五丈原的陡坡：台地四周一圈岩壁，只有東面坡道和西南往斜谷的路
  rocks: [[2200, 2900, 900, 150], [1100, 3500, 160, 500], [2900, 4500, 700, 140], [3150, 3000, 160, 300], [3100, 4150, 200, 260], [7600, 3600, 500, 260], [7400, 900, 400, 200]],
  woods: 0.35,
  sight: 1,
  clearings: [[CAMP[0], CAMP[1], 800], [YUAN[0], YUAN[1], 650], [BEIYUAN[0], BEIYUAN[1], 400], [GATE[0] - 500, GATE[1], 500], [HALT[0], HALT[1], 400]],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 10, r: 480, chief: true, col: '#3b5a99', flag: '司馬' }, { x: YUAN[0], y: YUAN[1], n: 9, r: 460, chief: true, col: '#4a6a3a', flag: '漢' }, { x: BEIYUAN[0], y: BEIYUAN[1], n: 3, r: 240, col: '#3b5a99', flag: '郭' }],
  fields: [[4300, 2500, 600, 260], [6800, 2600, 560, 240], [3700, 4300, 420, 200, '#86803f']], // 渭濱的田：蜀軍屯田，「耕者雜於渭濱居民之間」
  villages: [{ x: 6900, y: 3600, n: 5, r: 340 }],
};
